import AnalyticsSidebar from './AnalyticsSidebar.jsx';
import TopBar from './TopBar.jsx';

/** Layout shell for the Upgrade Weekend analytics command center — mirrors the
 *  XM/Sentiment layouts but with the analytics sidebar. */
export default function AnalyticsLayout({ title = 'Upgrade Related Website Analytics', children }) {
  return (
    <div className="layout">
      <AnalyticsSidebar />
      <main className="main">
        <TopBar title={title} />
        <div className="content">{children}</div>
      </main>
    </div>
  );
}
